module.exports = __webpack_public_path__ + "static/betterer-arms-folded-ca2a2dccb236a76fa2b66a822f0460fe.png";